import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout';
import {
  HomePage,
  ServicesPage,
  FAQPage,
  ContactPage,
  BookAppointmentPage,
  BlogPage,
  BlogPostPage,
  NotFoundPage,
} from './pages';

/**
 * Main App component with routing
 */
function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="faq" element={<FAQPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="book-appointment" element={<BookAppointmentPage />} />
        <Route path="blog" element={<BlogPage />} />
        <Route path="blog/tags/:tag" element={<BlogPage />} />
        <Route path="blog/:slug" element={<BlogPostPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export default App;
